module.exports = __webpack_public_path__ + "img/stick_activites_centre_equestre.b389b32e.svg";